import React from "react";
import { connect, ConnectedProps } from 'react-redux'
import { reduxActions } from '../../../../../store'
import { Prompt } from 'react-router';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { DefaultButton, Dialog, DialogFooter, DialogType, IButtonStyles, IDialogContentProps, IDropdownOption, MessageBar, MessageBarType, PrimaryButton } from "@fluentui/react";
import { Steps } from 'primereact/steps';
import { RootState } from "../../../../../store";
import { IChoiceField, ICodiceLavorazionePostel, IField, IPrintAndSendRequest, IProtocol, ITextField } from "../../../../../shared/interfaces";
import protocolsService from "../../../../../services/protocols.service";
import RippleLoader from "../../../../Loader/RippleLoader/RippleLoader";
import CircleLoader from "../../../../Loader/CircleLoader/CircleLoader";
import { Unsubscribe } from "@casl/ability";
import abilityBuild from '../../../../../shared/CASL/appAbility';
import AppUtilities from "../../../../../shared/Utilities/appUtilities";
import FormUserPrintAndSend from "./FormUserPrintAndSend";
import FormSendType from "./FormSendType";
import printAndSendService from "../../../../../services/printAndSend.service";
import { PrintAndSendWizardReduxState } from "../../../../../store/print-and-send-wizard/types";
import { Protocol_State } from "../../../../../shared/enums";
import { toastRef } from "../../../../Layout/Layout";


const forwardButtonStyles: Partial<IButtonStyles> = {
    flexContainer: {
        flexDirection: 'row-reverse'
    }
}

const mittenteFields = [
    {
        displayName: "Nome/Ragione sociale",
        internalName: "nomeRagioneSocialeMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
    } as ITextField,
    {
        displayName: "Indirizzo",
        internalName: "indirizzoMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 132,

    } as ITextField,
    {
        displayName: "CAP",
        internalName: "capMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        maxLength: 5,
    } as ITextField,
    {
        displayName: "Città",
        internalName: "cittaMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 44,
    } as ITextField,
    {
        displayName: "Provincia",
        internalName: "provinciaMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 2,
        toUpper: true
    } as ITextField,
    {
        displayName: "Nazione",
        internalName: "nazioneMittente",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 2,
        toUpper: true
    } as ITextField
];

const destinatarioFields = [
    {
        displayName: "Nome/Ragione sociale",
        internalName: "nomeRagioneSocialeDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false
    } as ITextField,
    {
        displayName: "Indirizzo",
        internalName: "indirizzoDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 132,
    } as ITextField,
    {
        displayName: "CAP",
        internalName: "capDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        maxLength: 5,
    } as ITextField,
    {
        displayName: "Città",
        internalName: "cittaDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 44,
    } as ITextField,
    {
        displayName: "Provincia",
        internalName: "provinciaDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 2,
        toUpper: true
    } as ITextField,
    {
        displayName: "Nazione",
        internalName: "nazioneDestinatario",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        maxLength: 2,
        toUpper: true
    } as ITextField,
];

const sendTypeFields = [
    {
        displayName: "Documento da inviare",
        internalName: "nomeDocumento",
        controlType: "dropdown",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Tipo di Invio",
        internalName: "tipoInvio",
        controlType: "dropdown",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Colore",
        internalName: "isColore",
        sharepointType: "Boolean",
        controlType: "boolean",
        required: false,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: false,
        valid: false,
        touched: false
    } as IField,
    {
        displayName: "Fronte/Retro",
        internalName: "isFronteRetro",
        sharepointType: "Boolean",
        controlType: "boolean",
        required: false,
        readonly: true,
        disabled: false,
        system: false,
        internalValue: false,
        valid: false,
        touched: false,
    } as IField,
];

const mapState = (state: RootState) => ({
    currentProtocol: state.protocolWizardReducer.protocol,
    stepIndex: state.protocolWizardReducer.stepIndex,
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,


    mittentePrintAndSendFields: state.printAndSendWizardReducer.mittentePrintAndSendFields,
    destinatarioPrintAndSendFields: state.printAndSendWizardReducer.destinatarioPrintAndSendFields,
    sendTypePrintAndSendFields: state.printAndSendWizardReducer.sendTypePrintAndSendFields,
    codiciLavorazione: state.printAndSendWizardReducer.codiciLavorazione,
})

const mapDispatch = {
    nextStepIndex: () => (reduxActions.printAndSendWizardActions.nextStepIndex()),
    previousStepIndex: () => (reduxActions.printAndSendWizardActions.previousStepIndex()),
    setStepIndex: (stepIndex: number) => (reduxActions.printAndSendWizardActions.setStepIndex(stepIndex)),
    updatePrintAndSendWizardState: (printAndSendWizardState: Partial<PrintAndSendWizardReduxState>) => (reduxActions.printAndSendWizardActions.updatePrintAndSendWizardState(printAndSendWizardState)),
    resetPrintAndSendFields: () => (reduxActions.printAndSendWizardActions.resetPrintAndSendFields()),
    setActiveAccordionIndex: (accordionIndex: number) => (reduxActions.printAndSendWizardActions.setActiveAccordionIndex(accordionIndex)),
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>


export interface PrintAndSendWizardProps {
    protocol?: IProtocol,
}
export interface PrintAndSendWizardState {
    stepItems: any[],

    createPrintAndSendDialogIsOpen: boolean,
    createPrintAndSendDialogContentProps: IDialogContentProps,
    createPrintAndSendDialogSubmitFunction: Function

    shouldBlockNavigation: boolean

    isLoadingWizard: boolean,
    showActionsLoader: boolean

    showMessageBar: boolean
    messageBarType: MessageBarType,
    messageBarText: string,

}
type Props = PrintAndSendWizardProps & RouteComponentProps & PropsFromRedux


class PrintAndSendWizard extends React.Component<Props, PrintAndSendWizardState> {
    unsubscribeFromAbility: Unsubscribe = () => { };

    state: PrintAndSendWizardState = {
        isLoadingWizard: false,
        stepItems: [
            {
                label: 'Mittente',
                command: (event) => {

                }
            },
            {
                label: 'Destinatario',
                command: (event) => {

                }
            },
            {
                label: 'Tipo di invio',
                command: (event) => {

                }
            },
        ],
        shouldBlockNavigation: false,
        createPrintAndSendDialogIsOpen: false,
        createPrintAndSendDialogContentProps: {},
        createPrintAndSendDialogSubmitFunction: () => { },
        showActionsLoader: false,
        showMessageBar: false,
        messageBarType: MessageBarType.info,
        messageBarText: "",
    }

    async componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('send', 'IPrintAndSend')) {
                this.props.history.push({ pathname: '/unauthorized', search: this.props.location.search });
            }
        });

        if (!this.props.codiciLavorazione || this.props.codiciLavorazione.length == 0) {
            this.setState({ isLoadingWizard: true });
            printAndSendService.getCodiciLavorazione(this.props.currentAoo!.id!, this.props.currentUor!.id!)
                .then(response => {

                    let newCodiciLavorazione = [...response];
                    this.setPrintAndSendFieldsAndCodiciLavorazione(newCodiciLavorazione);
                });
        }
        else {
            let newCodiciLavorazione = [...this.props.codiciLavorazione];
            this.setPrintAndSendFieldsAndCodiciLavorazione(newCodiciLavorazione);
        }

    }

    componentDidUpdate(oldProps, oldState) {

        if (oldProps.currentProtocol !== this.props.currentProtocol && this.props.currentProtocol && this.props.currentUor) {
            this.setState({ shouldBlockNavigation: true })
            //////// Previene la chiusura del tab del browser e il refresh della pagina
            window.onbeforeunload = (event) => {
                const e = event || window.event;
                e.preventDefault();
                if (e) {
                    e.returnValue = true;
                }
                return true;
            };
            //////// 
        }

    }

    componentWillUnmount() {
        window.onbeforeunload = null;
        this.unsubscribeFromAbility();
    }

    setPrintAndSendFieldsAndCodiciLavorazione = (codiciLavorazione: ICodiceLavorazionePostel[]) => {
        //Ricavo le Options del documento
        let documentProtocollatoName: string;
        let documentOptions: any[] = [];

        //Se il documento è protocollato, mostro come nome del documento "Documento Protocollato"
        if (this.props.protocol!.statoProtocollo === Protocol_State.Protocollato) {
            documentProtocollatoName = "Documento Protocollato";
            let docBase64String = this.props.protocol!.documentFile?.docBase64String;
            documentOptions.push({ text: documentProtocollatoName, key: documentProtocollatoName, docBase64: docBase64String });
        }

        //Se il documento ha allegati, prendo solo quelli con estensione .pdf
        if (this.props.protocol!.hasAttachments) {

            this.props.protocol!.attachments!.forEach(el => {
                let fileNameWithoutExtension = el.fileName.replace(".pdf", "");
                if (el.extension === ".pdf") {
                    return (documentOptions.push({ text: fileNameWithoutExtension, key: el.fileName }))
                }
            })
        }

        //Ricavo le Options del tipo di invio
        let tipiInvioOptions: IDropdownOption[] = [...codiciLavorazione.filter((element, index, array) => array.findIndex((m) => m.tipo === element.tipo) === index)
            .map(item => ({ text: item.tipo, key: item.tipo }))];


        let newSendTypeFields = [...sendTypeFields];

        let typeFieldIndex = newSendTypeFields.findIndex(el => el.internalName === 'tipoInvio');
        let newTypeField = { ...newSendTypeFields[typeFieldIndex] } as IChoiceField;
        newTypeField.options = tipiInvioOptions;

        newSendTypeFields[typeFieldIndex] = { ...newTypeField };

        let documentoFieldIndex = newSendTypeFields.findIndex(el => el.internalName === 'nomeDocumento');
        let documentoField = { ...newSendTypeFields[documentoFieldIndex] } as IChoiceField;
        documentoField.options = documentOptions;

        newSendTypeFields[documentoFieldIndex] = { ...documentoField };

        let _mittenteFields = this.props.mittentePrintAndSendFields ? [...this.props.mittentePrintAndSendFields] : [...mittenteFields];
        let _destinatarioFields = this.props.destinatarioPrintAndSendFields ? [...this.props.destinatarioPrintAndSendFields] : [...destinatarioFields];
        let _sendTypeFields = this.props.sendTypePrintAndSendFields ? [...this.props.sendTypePrintAndSendFields] : [...newSendTypeFields];

        this.props.updatePrintAndSendWizardState({
            mittentePrintAndSendFields: [..._mittenteFields],
            destinatarioPrintAndSendFields: [..._destinatarioFields],
            sendTypePrintAndSendFields: [..._sendTypeFields],
            codiciLavorazione: [...codiciLavorazione]
        });
        this.setState({ isLoadingWizard: false });

    }

    // Click sul button invia del wizard
    addNewSpedizioneHandler = async (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.checkPrintAndSendWizardValidity()) {

            this.setState({
                createPrintAndSendDialogIsOpen: true,
                createPrintAndSendDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: 'Vuoi creare una nuova spedizione?',
                },
                createPrintAndSendDialogSubmitFunction: () => { this.sendPrintAndSendRequestConfirmDialogSubmit() }
            })
        }
    }

    sendPrintAndSendRequestConfirmDialogSubmit = async () => {
        this.setState({ createPrintAndSendDialogIsOpen: false, showActionsLoader: true })

        let printAndSendRequest = await this.createPrintAndSendRequest();

        let _codiciLavorazione = [...this.props.codiciLavorazione!];
        let workProcessId = _codiciLavorazione!.find(el => el.tipo == printAndSendRequest.tipoInvio && el.colore == printAndSendRequest.isColore && el.fronteRetro == printAndSendRequest.isFronteRetro);
        printAndSendService.send(this.props.currentAoo!.id!, this.props.currentUor!.id!, workProcessId!.workProcessId, printAndSendRequest)
            .then(result => {

                this.setState({ showActionsLoader: false });
                toastRef.current?.show({ severity: 'info', summary: 'Stampa e Invia', detail: `Spedizione inviata correttamente`, life: 5000 });



                this.props.updatePrintAndSendWizardState({
                    activeAccordionIndex: 0,
                    mittentePrintAndSendFields: undefined,
                    destinatarioPrintAndSendFields: undefined,
                    sendTypePrintAndSendFields: undefined,
                    stepIndex: 0,
                    valid: undefined,
                    touched: undefined

                });

                setTimeout(() => {
                    this.setPrintAndSendFieldsAndCodiciLavorazione(_codiciLavorazione);
                }, 500);

            }).catch(error => {
                this.setState({
                    showActionsLoader: false,
                    showMessageBar: true,
                    messageBarType: MessageBarType.error,
                    messageBarText: 'Errore nella creazione della spedizione'
                })
            })
    }

    createPrintAndSendRequest = async (): Promise<IPrintAndSendRequest> => {

        //Prendo i valori del mittente
        let mittenteFields = [...this.props.mittentePrintAndSendFields!];
        let nomeMittente = mittenteFields.find(el => el.internalName === 'nomeRagioneSocialeMittente')?.internalValue;
        let indirizzoMittente = mittenteFields.find(el => el.internalName === 'indirizzoMittente')?.internalValue;
        let capMittente = mittenteFields.find(el => el.internalName === 'capMittente')?.internalValue;
        let cittaMittente = mittenteFields.find(el => el.internalName === 'cittaMittente')?.internalValue;
        let provinciaMittente = mittenteFields.find(el => el.internalName === 'provinciaMittente')?.internalValue;
        let nazioneMittente = mittenteFields.find(el => el.internalName === 'nazioneMittente')?.internalValue;

        //Prendo i valori del destinatario
        let destinatarioFields = [...this.props.destinatarioPrintAndSendFields!];
        let nomeDestinatario = destinatarioFields.find(el => el.internalName === 'nomeRagioneSocialeDestinatario')?.internalValue;
        let indirizzoDestinatario = destinatarioFields.find(el => el.internalName === 'indirizzoDestinatario')?.internalValue;
        let capDestinatario = destinatarioFields.find(el => el.internalName === 'capDestinatario')?.internalValue;
        let cittaDestinatario = destinatarioFields.find(el => el.internalName === 'cittaDestinatario')?.internalValue;
        let provinciaDestinatario = destinatarioFields.find(el => el.internalName === 'provinciaDestinatario')?.internalValue;
        let nazioneDestinatario = destinatarioFields.find(el => el.internalName === 'nazioneDestinatario')?.internalValue;

        //Prendo i valori di sendType
        let sendTypeFields = [...this.props.sendTypePrintAndSendFields!];
        let nomeDocumento = sendTypeFields.find(el => el.internalName === 'nomeDocumento')?.internalValue;
        let tipoInvio = sendTypeFields.find(el => el.internalName === 'tipoInvio')?.internalValue;
        let isColore = sendTypeFields.find(el => el.internalName === 'isColore')?.internalValue;
        let isFronteRetro = sendTypeFields.find(el => el.internalName === 'isFronteRetro')?.internalValue;



        let docBase64String;


        let documentoSelezionatoField = sendTypeFields.find(el => el.internalName === 'nomeDocumento') as IChoiceField;
        if (documentoSelezionatoField?.internalValue === "Documento Protocollato") {
            let optionsField = documentoSelezionatoField.options;
            let optionObject = optionsField.find(el => el.docBase64);
            docBase64String = optionObject["docBase64"];

        } else {
            docBase64String = await this.getAttachmentBase64String(nomeDocumento);
        }

        const printAndSendRequestObject: IPrintAndSendRequest = {
            idAoo: this.props.currentAoo!.id,
            idProtocollo: this.props.protocol!.id!,
            mittente: {
                nomeRagioneSociale: nomeMittente,
                indirizzo: indirizzoMittente,
                cap: capMittente,
                citta: cittaMittente,
                provincia: provinciaMittente.toUpperCase(),
                nazione: nazioneMittente.toUpperCase()
            },
            destinatario: {
                nomeRagioneSociale: nomeDestinatario,
                indirizzo: indirizzoDestinatario,
                cap: capDestinatario,
                citta: cittaDestinatario,
                provincia: provinciaDestinatario.toUpperCase(),
                nazione: nazioneDestinatario.toUpperCase()
            },
            tipoInvio: tipoInvio,
            nomeDocumento: nomeDocumento,
            isColore: isColore,
            isFronteRetro: isFronteRetro,
            docBase64String: docBase64String
        };

        return printAndSendRequestObject;
    }

    getAttachmentBase64String = async (nomeDocumento): Promise<IPrintAndSendRequest> => {
        let docBase64String;

        await protocolsService.getAttachmentBase64String(this.props.currentAoo!.id, this.props.currentUor!.id, this.props.protocol!.id!, nomeDocumento)
            .then(file => {
                docBase64String = file.docBase64String!;
            }).catch(error => {
                return null;
            })
        return docBase64String;
    }

    dismissPrintAndSendDialog = () => {
        this.setState({ createPrintAndSendDialogIsOpen: false })
    }

    onForwardButtonClick = () => {
        if (this.props.stepIndex < this.state.stepItems.length - 1) {
            this.props.nextStepIndex();
        }
    }
    onBackButtonClick = () => {
        if (this.props.stepIndex > 0) {
            this.props.previousStepIndex();
        }
    }
    onStepIndexClick = (index: number) => {
        this.props.setStepIndex(index)
    }

    checkPrintAndSendWizardValidity = (): boolean => {
        let isValid = true;
        let errors = {};
        const currentPrintAndSendWizardState: Partial<PrintAndSendWizardReduxState> = {
            ...this.props.updatePrintAndSendWizardState
        }

        //Validazione dei fields per mittente
        let printAndSendMittente = [...this.props.mittentePrintAndSendFields!];
        if (printAndSendMittente) {
            const updatedMittenteFields = printAndSendMittente!.map((item, index) => {
                let fieldValidity = AppUtilities.checkFieldValidity(item);
                if (!fieldValidity) {
                    isValid = false;
                    errors["mittente"] = " Mittente";
                }
                return {
                    ...item,
                    touched: true,
                    valid: fieldValidity
                }
            });

            currentPrintAndSendWizardState.valid = isValid;
            currentPrintAndSendWizardState.touched = true;

            this.props.updatePrintAndSendWizardState({
                ...currentPrintAndSendWizardState,
                mittentePrintAndSendFields: updatedMittenteFields,
                valid: isValid,
                touched: true,
            });
        }

        //Validazione dei fields per destinatario
        let printAndSendDestinatario = [...this.props.destinatarioPrintAndSendFields!];
        if (printAndSendDestinatario) {
            const updatedDestinatarioFields = printAndSendDestinatario!.map((item, index) => {
                let fieldValidity = AppUtilities.checkFieldValidity(item);
                if (!fieldValidity) {
                    isValid = false;
                    errors["destinatario"] = " Destinatario";
                }
                return {
                    ...item,
                    touched: true,
                    valid: fieldValidity
                }
            });

            currentPrintAndSendWizardState.valid = isValid;
            currentPrintAndSendWizardState.touched = true;

            this.props.updatePrintAndSendWizardState({
                ...currentPrintAndSendWizardState,
                destinatarioPrintAndSendFields: updatedDestinatarioFields,
                valid: isValid,
                touched: true,
            });
        }

        //Validazione dei fields per sendType
        let printAndSendSendType = [...this.props.sendTypePrintAndSendFields!];
        if (printAndSendSendType) {
            const updatedSendTypeFields = printAndSendSendType!.map((item, index) => {
                let fieldValidity = AppUtilities.checkFieldValidity(item);
                if (!fieldValidity) {
                    isValid = false;
                    errors["sendType"] = " Tipo di invio";
                }
                return {
                    ...item,
                    touched: true,
                    valid: fieldValidity
                }
            });

            currentPrintAndSendWizardState.valid = isValid;
            currentPrintAndSendWizardState.touched = true;

            this.props.updatePrintAndSendWizardState({
                ...currentPrintAndSendWizardState,
                sendTypePrintAndSendFields: updatedSendTypeFields,
                valid: isValid,
                touched: true,
            });
        }

        let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);

        this.setState({
            showMessageBar: !isValid,
            messageBarType: MessageBarType.error,
            messageBarText: "Compilare i campi per: " + errorMessage
        });

        return isValid;
    }

    mittenteInputChangedHandler = (newField: IField) => {
        if (this.props.mittentePrintAndSendFields) {
            let printAndSendMittenteFields = [...this.props.mittentePrintAndSendFields];

            let itemIndex = printAndSendMittenteFields.findIndex(el => el.internalName === newField.internalName);
            printAndSendMittenteFields[itemIndex] = { ...newField };

            this.props.updatePrintAndSendWizardState({ mittentePrintAndSendFields: printAndSendMittenteFields })
        }
    }

    destinatarioInputChangedHandler = (newField: IField) => {
        if (this.props.destinatarioPrintAndSendFields) {
            let printAndSendDestinatarioFields = [...this.props.destinatarioPrintAndSendFields];

            let itemIndex = printAndSendDestinatarioFields.findIndex(el => el.internalName === newField.internalName);
            printAndSendDestinatarioFields[itemIndex] = { ...newField };

            this.props.updatePrintAndSendWizardState({ destinatarioPrintAndSendFields: printAndSendDestinatarioFields })
        }
    }

    sendTypeInputChangedHandler = (newField: IField) => {
        if (this.props.sendTypePrintAndSendFields) {
            let printAndSendSendTypeFields = [...this.props.sendTypePrintAndSendFields];


            if (this.props.codiciLavorazione) {
                let _codiciLavorazione = [...this.props.codiciLavorazione];

                if (newField.internalName === 'tipoInvio') {
                    let workProcessIdsForSelectedType = _codiciLavorazione.filter(el => el.tipo === newField.internalValue);

                    let distinctColore = [...Array.from(new Set(workProcessIdsForSelectedType.map(el => el.colore)))];
                    let isColoreReadonly = distinctColore.length != 2;
                    let isColoreValue = distinctColore.length == 1 ? distinctColore[0] : false;

                    let coloreFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "isColore");
                    let coloreField = { ...printAndSendSendTypeFields[coloreFieldIndex] };
                    coloreField.internalValue = isColoreValue;
                    coloreField.readonly = isColoreReadonly;

                    printAndSendSendTypeFields[coloreFieldIndex] = { ...coloreField };


                    let distinctFronteRetro: any[] = [];
                    workProcessIdsForSelectedType.forEach(el => {
                        if (el.colore == isColoreValue) {
                            distinctFronteRetro.push(el.fronteRetro);
                        }
                    });
                    let isFronteRetroReadonly = distinctFronteRetro.length != 2;

                    let fronteRetroFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "isFronteRetro");
                    let fronteRetroField = { ...printAndSendSendTypeFields[fronteRetroFieldIndex] };
                    if (distinctFronteRetro.length == 1) {
                        fronteRetroField.internalValue = distinctFronteRetro[0];
                    }
                    fronteRetroField.readonly = isFronteRetroReadonly;

                    printAndSendSendTypeFields[fronteRetroFieldIndex] = { ...fronteRetroField };

                }
                else if (newField.internalName === 'isColore') {
                    let tipoInvioFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "tipoInvio");
                    let tipoInvioField = { ...printAndSendSendTypeFields[tipoInvioFieldIndex] };

                    let workProcessIdsForSelectedType = _codiciLavorazione.filter(el => el.tipo === tipoInvioField.internalValue);

                    let distinctFronteRetro: any[] = [];
                    workProcessIdsForSelectedType.forEach(el => {
                        if (el.colore == newField.internalValue) {
                            distinctFronteRetro.push(el.fronteRetro);
                        }
                    });
                    let isFronteRetroReadonly = distinctFronteRetro.length != 2;

                    let fronteRetroFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "isFronteRetro");
                    let fronteRetroField = { ...printAndSendSendTypeFields[fronteRetroFieldIndex] };
                    if (distinctFronteRetro.length == 1) {
                        fronteRetroField.internalValue = distinctFronteRetro[0];
                    }
                    fronteRetroField.readonly = isFronteRetroReadonly;

                    printAndSendSendTypeFields[fronteRetroFieldIndex] = { ...fronteRetroField };
                }
                else if (newField.internalName === 'isFronteRetro') {
                    let tipoInvioFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "tipoInvio");
                    let tipoInvioField = { ...printAndSendSendTypeFields[tipoInvioFieldIndex] };

                    let workProcessIdsForSelectedType = _codiciLavorazione.filter(el => el.tipo === tipoInvioField.internalValue);


                    let distinctColore: any[] = [];
                    workProcessIdsForSelectedType.forEach(el => {
                        if (el.fronteRetro == newField.internalValue) {
                            distinctColore.push(el.colore);
                        }
                    });
                    let isColoreReadonly = distinctColore.length != 2;

                    let coloreFieldIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === "isColore");
                    let coloreField = { ...printAndSendSendTypeFields[coloreFieldIndex] };
                    if (distinctColore.length == 1) {
                        coloreField.internalValue = distinctColore[0];
                    }
                    coloreField.readonly = isColoreReadonly;

                    printAndSendSendTypeFields[coloreFieldIndex] = { ...coloreField };

                }
            }

            let itemIndex = printAndSendSendTypeFields.findIndex(el => el.internalName === newField.internalName);
            printAndSendSendTypeFields[itemIndex] = { ...newField };

            this.props.updatePrintAndSendWizardState({ sendTypePrintAndSendFields: printAndSendSendTypeFields })
        }
    }

    stepElement = () => {
        switch (this.props.stepIndex) {
            case 0:
                return (
                    <React.Fragment>

                        <div className={`position-relative my-scroll-div`}>
                            <div className={'box-content'} style={{ paddingTop: "0" }}>
                                <FormUserPrintAndSend
                                    key={1}
                                    userPrintAndSend={this.props.mittentePrintAndSendFields!}
                                    onInputChangedHandler={(newField) => { this.mittenteInputChangedHandler(newField) }}
                                />
                            </div>
                        </div>

                    </React.Fragment>
                );

            case 1:
                return (
                    <React.Fragment>

                        <div className={`position-relative my-scroll-div`}>
                            <div className={'box-content'} style={{ paddingTop: "0" }}>
                                <FormUserPrintAndSend
                                    key={2}
                                    userPrintAndSend={this.props.destinatarioPrintAndSendFields!}
                                    onInputChangedHandler={(newField) => { this.destinatarioInputChangedHandler(newField) }}
                                />
                            </div>
                        </div>

                    </React.Fragment>
                );

            case 2:
                return (
                    <React.Fragment>

                        <div className={`position-relative my-scroll-div`}>
                            <div className={'box-content'} style={{ paddingTop: "0" }}>
                                <FormSendType
                                    key={3}
                                    protocol={this.props.protocol}
                                    onInputChangedHandler={(newField) => { this.sendTypeInputChangedHandler(newField) }}
                                />
                            </div>
                        </div>

                    </React.Fragment>
                );

        }
    }
    render() {


        return (
            <React.Fragment>
                <div className={`loader opacity ${this.state.showActionsLoader ? "active" : ''}`}>
                    <RippleLoader text='Invio della spedizione in corso' />
                </div>

                <div className='print-and-send-wizard-component flex flex-column p-nogutter  position-relative'>
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingWizard} />

                    <Prompt
                        when={this.state.shouldBlockNavigation}
                        message='Le modifiche apportate potrebbero non essere salvate, vuoi lasciare la pagina?'
                    />

                    {
                        this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={this.state.messageBarType}
                            isMultiline={false}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">{this.state.messageBarText}</MessageBar>
                    }

                    <Steps model={this.state.stepItems} activeIndex={this.props.stepIndex} onSelect={(e) => this.onStepIndexClick(e.index)} readOnly={false} />

                    <div className="flex flex-column lg:flex-row p-nogutter step-content">
                        {this.stepElement()}
                    </div>

                    <Dialog
                        hidden={!this.state.createPrintAndSendDialogIsOpen}
                        onDismiss={this.dismissPrintAndSendDialog}
                        dialogContentProps={this.state.createPrintAndSendDialogContentProps}>
                        <DialogFooter>
                            <PrimaryButton onClick={() => this.state.createPrintAndSendDialogSubmitFunction()} text="Conferma" />
                            <DefaultButton onClick={this.dismissPrintAndSendDialog} text="Annulla" />
                        </DialogFooter>
                    </Dialog>

                    {this.props.stepIndex === 0 || this.props.stepIndex === 1 ?

                        <div className="print-and-send-wizard-buttons">

                            <DefaultButton
                                primary
                                className='step-navigation-button'
                                text="Indietro"
                                iconProps={{ iconName: 'Back' }}
                                // By default, the ContextualMenu is re-created each time it's shown and destroyed when closed.
                                // Uncomment the next line to hide the ContextualMenu but persist it in the DOM instead.
                                // persistMenu={true}
                                allowDisabledFocus
                                disabled={this.props.stepIndex === 0}
                                onClick={this.onBackButtonClick}
                            />

                            <DefaultButton
                                primary
                                className='step-navigation-button'
                                text="Avanti"
                                styles={forwardButtonStyles}
                                iconProps={{ iconName: 'Forward' }}
                                allowDisabledFocus
                                disabled={this.props.stepIndex === this.state.stepItems.length - 1}
                                onClick={this.onForwardButtonClick}
                                style={{}}
                            />

                        </div>
                        :
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '25px', marginRight: '25px', marginTop: '20px' }} >
                            <DefaultButton
                                primary
                                className='step-navigation-button'
                                text="Indietro"
                                iconProps={{ iconName: 'Back' }}
                                allowDisabledFocus
                                disabled={this.props.stepIndex === 0}
                                onClick={this.onBackButtonClick}
                            />
                            <PrimaryButton
                                styles={{ root: { marginRight: 8, alignSelf: 'center', width: '30px' } }}
                                text="Invia"
                                onClick={this.addNewSpedizioneHandler} />
                        </div>
                    }

                </div>
            </React.Fragment>

        );
    }
}

export default connector(withRouter(PrintAndSendWizard));